import { render, staticRenderFns } from "./DashboardArchiveRecordings.vue?vue&type=template&id=b1e481e4&scoped=true"
import script from "./DashboardArchiveRecordings.vue?vue&type=script&lang=js"
export * from "./DashboardArchiveRecordings.vue?vue&type=script&lang=js"
import style0 from "./DashboardArchiveRecordings.vue?vue&type=style&index=0&id=b1e481e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e481e4",
  null
  
)

export default component.exports